import * as React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
const audiences = [{
  title: "Specifying engineers",
  url: "/industries/specifying-engineers/"
}, {
  title: "Panel builders (UL 508A)",
  url: "/industries/panel-builders-ul508a/"
}, {
  title: "Electrical contractors",
  url: "/industries/electrical-contractors/"
}, {
  title: "Data centers",
  url: "/industries/data-centers/"
}, {
  title: "Utilities & power generation",
  url: "/industries/utilities-power-generation/"
}, {
  title: "Manufacturing facilities",
  url: "/industries/manufacturing/"
}];
export default function WhoOrdersArcFlashLabelsFromEvermark() {
  return <section id="who-orders-arc-flash-labels-from-evermark" className="bg-secondary py-16 md:py-24">
      <div className="container mx-auto px-4 md:px-6 max-w-5xl">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold font-default text-white mb-6">
            Who Orders Arc Flash Labels From Evermark?
          </h2>
          <p className="text-lg text-gray-300 max-w-3xl mx-auto">
            Evermark Industrial Solutions produces arc flash labels for the people who specify, install, and maintain electrical equipment:
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-12">
          {audiences.map((audience, i) => <Link key={i} to={audience.url} className="block group outline-none focus-visible:ring-2 focus-visible:ring-ring rounded-xl" data-index={i}>
              <Card className="h-full bg-card border-border/50 hover:border-primary/50 transition-colors duration-300 shadow-sm hover:shadow-md">
                <CardContent className="p-6 flex items-center justify-between h-full">
                  <span className="font-semibold text-card-foreground group-hover:text-primary transition-colors">
                    {audience.title}
                  </span>
                  <ArrowRight className="w-5 h-5 text-primary opacity-0 group-hover:opacity-100 transition-all transform -translate-x-2 group-hover:translate-x-0" />
                </CardContent>
              </Card>
            </Link>)}
        </div>

        
      </div>
    </section>;
}